/* POSTED — "Use my current location" for the Google Maps link field.
   Fills the field with a maps.google.com link to the exact coordinates; the QR on the label opens that same point. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-posted-locate]');
  if (!button) return;
  const fields = button.closest('.posted-product__fields, .posted-req__fields') || document;
  const input = fields.querySelector('[data-posted-maps]');
  const status = button.closest('[data-posted-locate-scope]')?.querySelector('[data-posted-locate-status]');
  const say = (text, tone) => {
    if (!status) return;
    status.textContent = text;
    status.dataset.tone = tone || '';
  };
  if (!input || !('geolocation' in navigator)) return say(button.dataset.unavailable, 'error');

  const label = button.querySelector('span');
  const idle = label.textContent;
  button.disabled = true;
  label.textContent = button.dataset.busy;
  say('');
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      input.value = `https://maps.google.com/?q=${coords.latitude.toFixed(6)},${coords.longitude.toFixed(6)}`;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      say(button.dataset.done, 'done');
      button.disabled = false;
      label.textContent = idle;
    },
    (error) => {
      say(error.code === 1 ? button.dataset.denied : button.dataset.unavailable, 'error');
      button.disabled = false;
      label.textContent = idle;
    },
    { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }
  );
});
